"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLES = exports.USER_CONTEXT_INVITED_NOTARY = exports.USER_CONTEXT_NOTARY = exports.USER_CONTEXT_CUSTOMER = exports.CLIENT_UI_VARIANT = exports.SHARED_NOTARY_UI_VARIANT = exports.SHARED_NOTARY_TAB_TYPE = exports.TAB_TYPE_SHARED_NOTARY = exports.TAB_TYPE_THIRD_PARTY = exports.TAB_TYPE_CUSTOMER = exports.THIRD_PARTY_UI_VARIANT = exports.USER_CONTEXT_THIRD_PARTY = exports.MEMBER_CONTEXT_INVITED_NOTARY = exports.MEMBER_CONTEXT_THIRD_PARTY = exports.MEMBER_CONTEXT_CUSTOMER = exports.ROLE_GUEST_NOTARY = exports.ROLE_NOTARY = exports.ROLE_CLIENT = exports.USER_TYPE_CUSTOMER = exports.USER_TYPE_THIRDPARTY = void 0;
exports.isGuestNotary = isGuestNotary;
exports.isNotaryRole = isNotaryRole;
exports.isRole = isRole;
exports.isThirdParty = isThirdParty;
exports.isCustomer = isCustomer;
exports.isClientSpaceUserContext = isClientSpaceUserContext;
exports.USER_TYPE_THIRDPARTY = "thirdparty";
exports.USER_TYPE_CUSTOMER = "customer";
exports.ROLE_CLIENT = "client";
exports.ROLE_NOTARY = "notary";
exports.ROLE_GUEST_NOTARY = "guest_notary";
exports.MEMBER_CONTEXT_CUSTOMER = "customer";
exports.MEMBER_CONTEXT_THIRD_PARTY = "third_party";
exports.MEMBER_CONTEXT_INVITED_NOTARY = "invited_notary";
exports.USER_CONTEXT_THIRD_PARTY = exports.MEMBER_CONTEXT_THIRD_PARTY;
exports.THIRD_PARTY_UI_VARIANT = "third-party";
exports.TAB_TYPE_CUSTOMER = "customer";
exports.TAB_TYPE_THIRD_PARTY = "third_party";
exports.TAB_TYPE_SHARED_NOTARY = "shared_notary";
exports.SHARED_NOTARY_TAB_TYPE = exports.TAB_TYPE_SHARED_NOTARY;
exports.SHARED_NOTARY_UI_VARIANT = "shared-notary";
exports.CLIENT_UI_VARIANT = "client";
exports.USER_CONTEXT_CUSTOMER = exports.MEMBER_CONTEXT_CUSTOMER;
exports.USER_CONTEXT_NOTARY = exports.ROLE_NOTARY;
exports.USER_CONTEXT_INVITED_NOTARY = exports.MEMBER_CONTEXT_INVITED_NOTARY;
function isGuestNotary(value) {
    return value === exports.ROLE_GUEST_NOTARY;
}
function isNotaryRole(value) {
    return value === exports.ROLE_NOTARY || value === "collaborator" || value === "admin" || value === "super-admin";
}
exports.ROLES = [
    "super-admin",
    "admin",
    "notary",
    "collaborator",
    "guest_notary",
    "client",
    "thirdparty",
];
function isRole(value) {
    return value != null && exports.ROLES.includes(value);
}
function isThirdParty(value) {
    if (value == null) {
        return false;
    }
    const normalized = value.toLowerCase().replace(/[_-]/g, "");
    return normalized === "thirdparty";
}
function isCustomer(value) {
    return value === exports.USER_TYPE_CUSTOMER || value === exports.ROLE_CLIENT;
}
function isClientSpaceUserContext(value) {
    return (value === exports.USER_CONTEXT_CUSTOMER ||
        value === exports.USER_CONTEXT_THIRD_PARTY ||
        value === exports.USER_CONTEXT_INVITED_NOTARY);
}
